var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"personal-data",attrs:{"data-cy":"personal-data"}},[_c('div',{staticClass:"section"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('common.titles.personalData')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }